<template>
  <div
    class="multiImagesContainer"
    @click="openGalleryView"
  >
    <div
      class="thumbContainer"
      v-for="(image, index) in imagesNew"
      :key="index + 'MMI' + message.MessageID"
    >
      <img
        :class="[
          images.length === 3 ? 'oneThird' : '',
          images.length === 5 && index === 4 ? 'fifthImage' : '',
          'imageThumb'
        ]"
        :src="image"
      >
    </div>
    <div
      class="moreImagesBox"
      v-if="images.length > 6"
    >
      <img
        class="imageThumb"
        :src="images[5]"
      >
      <div class="moreTextOverlay">
        <div>
          {{ images.length - 5 }} fotoğraf<br>
          daha
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '@/eventbus.js'
import {
  messageMixin
} from '@/mixins/messageMixin.js'
export default {

  props: {
    message: {
      type: Object,
      default: function () {
        return {}
      }
    },
    images: {
      type: Array,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      imagesNew: []
    }
  },
  mixins: [messageMixin],
  methods: {
    imageV2 (image) {
      var vm = this
      return new Promise(function (resolve, reject) {
        if (vm.message.mv <= 1) {
          resolve(vm.makeBlob(image, image))
        } else {
          let key = '6a61e395-b49a-4468-bee0-27644e95308f'
          var iv = key.split('').reverse().join('')
          let encryptedBody = vm.ewk(image, key, iv)
          resolve(vm.makeBlob(process.env.VUE_APP_UPLOADURL2 + '/gfe?fn=' + image + '&s=' + encodeURIComponent(encryptedBody), image))
        }
      })
    },
    openGalleryView () {
      var vm = this
      this.$store.state.conversation.activeConversation.preview.imageGalleryView.isVisible = true
      setTimeout(function () {
        EventBus.$emit('imageGalleryViewOpenedWithMessage', vm.message)
      }, 50)
    }
  },
  computed: {
    visibleImages () {
      let newArray = this.images.slice()
      if (newArray.length > 6) {
        newArray.splice(5, newArray.length - 5)
      }

      return newArray
    }
  },
  mounted () {
    this.imagesNew = []
    var vm = this
    for (const iterator of this.visibleImages) {
      this.imageV2(iterator).then(function (response) {
        vm.imagesNew.push(response)
      }).catch(function (error) {
        vm.imagesNew.push('sdadas' + iterator)
      })
    }
  }
}
</script>

<style scoped>
.multiImagesContainer {
  width: 300px;
  max-height: 300px;
  display: flex;
  flex-wrap: wrap;
  cursor: pointer;
}

.thumbContainer {
  display: flex;
}

.imageThumb {
  width: 150px;
  height: 100px;
  object-fit: cover;
  margin: 0px;
}

.oneThird {
  width: 100px;
}

.fifthImage {
  width: 300px;
}

.moreImagesBox {
  background-color: white;
  width: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.moreTextOverlay {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 20px;
  font-weight: 300;
}
</style>
